import { Cell, FormControl, Grid } from 'bold-ui'
import {
  DateField,
  ErrorField,
  Form,
  FormPrompt,
  FormRenderProps,
  PecFormApi,
  resetAllFieldStates,
  SubmitButton,
} from 'components/form'
import { subDays } from 'date-fns'
import React from 'react'
import { toDate } from 'util/date/formatDate'
import { metaPath } from 'util/metaPath'
import { ForcaMuscularMaoField } from 'view/atendimentos/components/MedicoesPanel/ForcaMuscularMaoField'

import { MedicaoAnteriorModel } from '../model-medicoes'
import { MedicaoAnteriorExameFisicoFormModel } from './model-medicaoAnteriorExameFisico'
import { convertMedicaoAnteriorExameFisicoFormModelToMedicaoAnteriorModel } from './utils-medicaoAnteriorExameFisico'
import { medicaoAnteriorExameFisicoValidator } from './validator-medicaoAnteriorExameFisico'

interface MedicaoExameFisicoAnteriorFormProps {
  dataAtendimento: Instant
  dataNascimentoCidadao: LocalDate
  onSubmit: (medicao: MedicaoAnteriorModel) => void
}

const meta = metaPath<MedicaoAnteriorExameFisicoFormModel>()

export function MedicaoExameFisicoAnteriorForm(props: Readonly<MedicaoExameFisicoAnteriorFormProps>) {
  const { dataAtendimento, dataNascimentoCidadao, onSubmit } = props

  const handleSubmit = (
    values: MedicaoAnteriorExameFisicoFormModel,
    form: PecFormApi<MedicaoAnteriorExameFisicoFormModel>
  ) => {
    const convertedValues = convertMedicaoAnteriorExameFisicoFormModelToMedicaoAnteriorModel(values)
    onSubmit(convertedValues)
    resetAllFieldStates(form)
    setTimeout(form.reset)
  }

  const renderForm = (renderFormProps: FormRenderProps<MedicaoAnteriorExameFisicoFormModel>) => {
    return (
      <>
        <FormPrompt />
        <Grid gap={2}>
          <ErrorField type='alert' name={meta.error} wrapper={ErrorFieldWrapper} />
          <Cell size={3}>
            <DateField
              name={meta.data}
              label='Data da medição anterior'
              minDate={toDate(dataNascimentoCidadao)}
              maxDate={subDays(toDate(dataAtendimento), 1)}
              required
            />
          </Cell>
          <Cell size={9} />
          <Cell size={5}>
            <ForcaMuscularMaoField
              name={{ valor: meta.valorForcaMuscMaoDireita, unidade: meta.unidadeForcaMuscMaoDireita }}
              label={{
                valor: 'Mão direita',
                unidade: <span>&nbsp;</span>,
              }}
            />
          </Cell>
          <Cell size={5}>
            <ForcaMuscularMaoField
              name={{ valor: meta.valorForcaMuscMaoEsquerda, unidade: meta.unidadeForcaMuscMaoEsquerda }}
              label={{
                valor: 'Mão esquerda',
                unidade: <span>&nbsp;</span>,
              }}
            />
          </Cell>
          <Cell size={2}>
            <FormControl label={<span>&nbsp;</span>}>
              <SubmitButton handleSubmit={renderFormProps.handleSubmit} size='small' kind='primary'>
                Adicionar
              </SubmitButton>
            </FormControl>
          </Cell>
        </Grid>
      </>
    )
  }

  return (
    <Form<MedicaoAnteriorExameFisicoFormModel>
      suppressNotificationError
      render={renderForm}
      validate={medicaoAnteriorExameFisicoValidator(dataNascimentoCidadao, dataAtendimento)}
      onSubmit={handleSubmit}
    />
  )
}

const ErrorFieldWrapper = ({ children }: { children: React.ReactNode }) => <Cell size={12}>{children}</Cell>
